/* eslint-disable import/no-anonymous-default-export */
export default {
  index: () => "/",
  subscribe: () => "/subscribe",
  createPost: () => "/create-post",
  notFound: "/*",
  user: (username: string = ":username") => `user/${username}/`,
  userLikes: (username: string = ":username") => `user/${username}/likes`,
};